import React, { Fragment } from 'react';
import AsButton from '../AsButton';
import { getClaimValue } from '../adios';

const Row = ({ title, children }) => {
    return children ? (
        <Fragment>
            <span
                style={{
                    fontFamily: 'roboto',
                    fontSize: 14,
                    fontWeight: 'bold',
                    textAlign: 'center'
                }}
            >
                {title}:
            </span>

            <span style={{ fontFamily: 'roboto', fontSize: 14, fontWeight: 500 }}>{children}</span>
        </Fragment>
    ) : null;
};

const AboutThisModule = ({ onClose, visible = false }) => {
    return visible ? (
        <div
            id='aboutOverlay'
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                zIndex: 1040,
                width: '100%',
                height: '100%',
                overflow: 'hidden auto',
                outline: 0,
                boxSizing: 'border-box',
                backgroundColor: 'rgba(0, 0, 0, 0.4)'
            }}
        >
            <div
                id='aboutModal'
                style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, 1fr)',
                    boxSizing: 'border-box',
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: '#FFFFFF',
                    padding: '15px 30px',
                    borderRadius: 5,
                    gap: 10
                }}
            >
                <h1
                    id='aboutThisModule'
                    style={{
                        gridColumn: '1 / -1',
                        fontFamily: 'roboto',
                        fontSize: 22,
                        fontWeight: 'bold'
                    }}
                >
                    {window.translate('About this Module')}
                </h1>

                <Row title='Licence'>{getClaimValue('tenancyType')}</Row>
                <Row title='Company'>{getClaimValue('tenantName')}</Row>
                <Row title='Database'>{getClaimValue('tenantDBName')}</Row>
                <Row title='Module Version'>{window.COMMIT_HASH}</Row>
                <Row title='Build ID'>{window.BUILD_ID}</Row>
                <Row title='Build Tag'>{window.BUILD_TAG}</Row>
                <Row title='Build Node'>{window.NODE_NAME}</Row>
                <Row title='Executor ID'>{window.EXECUTOR_NUMBER}</Row>
                <Row title='Jenkins Job'>{window.JOB_NAME}</Row>

                {typeof onClose === 'function' && (
                    <div
                        id='ctaContainer'
                        style={{
                            gridColumn: '1 / -1',
                            display: 'flex',
                            justifyContent: 'center'
                        }}
                    >
                        <AsButton
                            id='aboutCloseBtn'
                            handleClick={onClose}
                            style={{
                                height: 34,
                                width: 'max-content',
                                padding: '5px 10px'
                            }}
                        >
                            {window.translate('Close')}
                        </AsButton>
                    </div>
                )}
            </div>
        </div>
    ) : null;
};

export default AboutThisModule;
